'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: flex-start;\n  cursor: pointer;\n  white-space: nowrap;\n  position: relative;\n  &:hover {\n    color: #6e0ad6 !important;\n    svg path {\n      fill: #6e0ad6 !important;\n    }\n  }\n\n  ', '\n'], ['\n  display: flex;\n  justify-content: flex-start;\n  cursor: pointer;\n  white-space: nowrap;\n  position: relative;\n  &:hover {\n    color: #6e0ad6 !important;\n    svg path {\n      fill: #6e0ad6 !important;\n    }\n  }\n\n  ', '\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      &:after {\n        content: \'\';\n        position: absolute;\n        left: 23px;\n        top: 7px;\n        background: #f28000;\n        border-style: solid;\n        width: 9px;\n        height: 9px;\n        border-radius: 100%;\n        border-color: white;\n        border-width: 3px;\n        pointer-events: none;\n      }\n    '], ['\n      &:after {\n        content: \'\';\n        position: absolute;\n        left: 23px;\n        top: 7px;\n        background: #f28000;\n        border-style: solid;\n        width: 9px;\n        height: 9px;\n        border-radius: 100%;\n        border-color: white;\n        border-width: 3px;\n        pointer-events: none;\n      }\n    ']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _LinkBox = require('../../molecules/LinkBox');
var _LinkBox2 = _interopRequireDefault(_LinkBox);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var myLinkBox = function myLinkBox(props) {
  var isLogged = props.isLogged,
    otherProps = (0, _objectWithoutProperties3.default)(props, ['isLogged']); // eslint-disable-line

  return _react2.default.createElement(_LinkBox2.default, otherProps, props.children);
};
var MyLinkBox = (0, _styledComponents2.default)(myLinkBox)(_templateObject, function (props) {
  return props.hasBadge && (0, _styledComponents.css)(_templateObject2);
});
exports.default = MyLinkBox;